require('./angular-aria');
module.exports = 'ngAria';



//////////////////
// WEBPACK FOOTER
// ../~/angular-aria/index.js
// module id = 378
// module chunks = 1